import { type PrescriptionDoctorApiOutContract } from 'api/generated/pwrdbyQuickMDProvidersApi.schemas'
import { isNoLongerLive } from './prescriptionStatus'

/**
 * A visit prescription as QMD-4913 (backend #2010) returns it: `GET /visits/{visitId}/prescriptions`
 * gains `IsHomeDelivery` beside the existing `Pharmacy`.
 *
 * `true` — the script goes to a QuickMD home-delivery pharmacy (order-only rows, which have no
 * prescription row, are also `true`); `false` — a pickup pharmacy. The backend always sends it;
 * absent means a deployment that predates the field, which every reader treats as "unknown" and
 * renders nothing for, never as pickup.
 *
 * TODO(QMD-4913): drop this extension once an environment's swagger serves `IsHomeDelivery` and
 * Orval generates it on `PrescriptionDoctorApiOutContract`.
 */
export type VisitPrescription = PrescriptionDoctorApiOutContract & {
  IsHomeDelivery?: boolean | null
}

export const QMD_PHARMACY_NAME = 'QMD Pharmacy'

/**
 * The second line of an order row: where the script was sent. `null` when the backend has not said,
 * and for a script that is no longer live (cancelled, or never reached the pharmacy), which is going
 * nowhere — the Requested pharmacy card stops warning about it too.
 */
export const fulfilmentLine = (
  prescription: Pick<VisitPrescription, 'IsHomeDelivery' | 'Pharmacy' | 'Status'>,
): string | null => {
  if (isNoLongerLive(prescription)) return null
  if (prescription.IsHomeDelivery === true) return `Home Delivery from ${QMD_PHARMACY_NAME}`
  if (prescription.IsHomeDelivery === false) {
    const name = prescription.Pharmacy?.Name
    return name ? `Pharmacy pickup at ${name}` : 'Pharmacy pickup'
  }
  return null
}
